import actions from '../../actionTypes';

export default action => {
  return {
    type: actions.ADDED_ACTION,
    action
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/addedAction.js